import React from 'react';
import { Button } from '@mui/material';
import { PaymentsCard, PaymentsContainer, PaymentsWrapper } from './Payments.styled';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../../config/routeConstants';
import {useTranslation} from 'react-i18next';

const PaymentSuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToChat = () => {
    navigate(`/${RoutePaths.Chat}`);
  };

  return (
    <PaymentsContainer>
      <PaymentsWrapper>
        <PaymentsCard>
          <h1>{t('paymentSuccess.title')}</h1>
          <p>{t('paymentSuccess.thankYou')}</p>
          <p>{t('paymentSuccess.continueServices')}</p>
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleGoToChat}
            sx={{ mt: 2, py: 1.5 }}
          >
            {t('paymentSuccess.goToChat')}
          </Button>
        </PaymentsCard>
      </PaymentsWrapper>
    </PaymentsContainer>
  );
};

export default PaymentSuccess;
